"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARNING = exports.INFO = exports.CRITICAL = void 0;
exports.CRITICAL = "critical";
exports.INFO = "info";
exports.WARNING = "warning";